import createAxiosInstance from './axiosConfig';

const axiosInstance = createAxiosInstance('payment');

export const makePayment = async (paymentData) => {
  try {
    const response = await axiosInstance.post('/payments', paymentData, {});
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const fetchOrder = async (orderId) => {
  const params = {};
  if (orderId) {
    params.account = orderId;
  }
  console.log('Fetching order with params:', params);
  return axiosInstance.get('/payments', { params });
};

export const initializePaystack = async (paymentData) => {
  try {
    const response = await axiosInstance.post(
      '/paymentIntegrations/paystackInitialize',
      paymentData
    );
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: error };
  }
};
